export const FINANCIAL_TRANSACTION_CONST = {
  ACCOUNT_PAYABLE: 1,
  ACCOUNT_RECEIVABLE: 2,
};